import { useEffect } from "react";
import { useStructureContext } from "../../../context/StructureContext";
import { areasTitles } from "../../../data/admin";
import StdTable from "./StdTable";

export default function BackupBox() {
  const { type, searchValues, openBackup, callBackupInfo } =
    useStructureContext();

  useEffect(() => {
    callBackupInfo();
  }, []);

  return "Z6" in searchValues ? (
    <div className="listBox">
      <StdTable
        type={type}
        style={{ width: "100%" }}
        header={areasTitles.BCK}
        data={"results" in searchValues.Z6 ? searchValues.Z6.results : []}
        onDoubleClick={(data) => openBackup(data.file)}
        className="listTableRow"
      />
    </div>
  ) : (
    <></>
  );
}
